module.exports = __webpack_public_path__ + "static/media/3.75900891.png";